// removed by extract-text-webpack-plugin
module.exports = {"ctqaTitle":"src-components-Practice-Material-explainByTtile-ctqaTitle-2ISSJ","ctqaContent":"src-components-Practice-Material-explainByTtile-ctqaContent-2j5Yb","ctqaImg":"src-components-Practice-Material-explainByTtile-ctqaImg-2zlZk","examName":"src-components-Practice-Material-explainByTtile-examName-1Nw_6","zhikeLogo":"src-components-Practice-Material-explainByTtile-zhikeLogo-3_eVx","goLook":"src-components-Practice-Material-explainByTtile-goLook-kWbSp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Practice/Material/explainByTtile.css
 ** module id = 273
 ** module chunks = 0
 **/